import queryString from 'query-string';
import { get, del, post } from './apiUtils';

const defaultUrl = '/SubstanceToxicologicalProfiles/';

export default {
  getSubstanceToxProfiles: ({ id, query } = {}) =>
    get(`${defaultUrl}${id || ''}${query ? '?'.concat(queryString.stringify(query)) : ''}`),
  deleteSubstanceToxProfile: id => del(`${defaultUrl}${id}`),
  saveSubstanceToxProfile: data => post(`${defaultUrl}`, data),
};
